export const environment = {
    ApiKey: '15EB4026-C1C8-4362-BB11-C3B113135754',
    urlAuth: 'https://vecor360.renault.com.co/ApiGeneral/api',
    url: 'https://vecor360.renault.com.co/ApiArchivos',
    urlSavec: 'https://vecor360.renault.com.co/ApiSavec',
};


//ng build --output-path dist/vecor360 --configuration production  --base-href /
